// Engagement policies: the notification log and the consent ledger are tenant records that its
// admins and managers may read; recording consent by hand is an admin act. Delivery itself is
// never a route (it is the `engagement.notification.requested` event), so there is no `send`.
// A person's phones and notification preferences are theirs alone: any member manages their
// own, and no role — not even TenantAdmin — reaches another person's.
import { allOf, isMember, isRole, isSelf } from '../policy/rules.js';
const tenantAdmin = isRole('TenantAdmin');
const adminOrManager = isRole('TenantAdmin', 'Manager');
export const notificationPolicy = {
    kind: 'notification',
    scope: 'tenant',
    actions: {
        list: adminOrManager,
        read: adminOrManager,
    },
};
export const consentPolicy = {
    kind: 'consent',
    scope: 'tenant',
    actions: {
        list: adminOrManager,
        record: tenantAdmin,
    },
};
const self = allOf(isMember, isSelf('sub'));
export const devicePolicy = {
    kind: 'device',
    scope: 'tenant',
    actions: {
        /** A member lists; the handler lists only the caller's own (the key is their sub). */
        list: isMember,
        register: self,
        remove: self,
    },
};
export const preferencePolicy = {
    kind: 'preference',
    scope: 'tenant',
    actions: {
        read: self,
        update: self,
    },
};
/**
 * Notices from platform staff (ADR in-app-notices-from-staff): any member reads the notices that
 * concern them and acknowledges them as themselves. Publishing is the platform's own action.
 */
export const noticePolicy = {
    kind: 'notice',
    scope: 'tenant',
    actions: {
        list: isMember,
        acknowledge: isMember,
    },
};
//# sourceMappingURL=engagement.js.map